import moment from 'moment'

export function status(value) {
  switch(value) { 
     case 'NEW':  
        return 'ใหม่'
     
     case 'PENDING':  
        return 'รอสอบถาม'
     
     case 'PROCEED': 
        return 'กำลังดำเนินการ'
     
     case 'COMPLETED': 
        return 'รับแล้ว'
    
     case 'CANCELED': 
        return 'ยกเลิก'
     
     default: 
        return ''
  }
}

export function statusColor(value) {
  switch(value) { 
     case 'ใหม่':  
        return 'orange'
     
     case 'รอสอบถาม':  
        return 'light-blue'
     
     case 'กำลังดำเนินการ': 
        return 'indigo'
     
     case 'รับแล้ว': 
        return 'success'
    
     case 'ยกเลิก': 
        return 'grey'
     
     default: 
        return 'blue-grey'
  }
}

export function courseType(value) {
  switch(value) { 
    case 'NORMAL':  
      return 'ปกติ'
     
    case 'INTER':  
      return 'นานาชาติ'

    case 'ARCH':  
      return 'นานาชาติ(บางขุนเทียน)'

    case 'RATC':  
      return 'ราชบุรี'
     
     default: 
        return ''
  }
}

export function subjectType(value) {
  switch(value) { 
     case 'MANDATORY':  
        return 'บังคับ'
     
     case 'ELECTIVE':  
        return 'บังคับเลือก'
     
     default: 
        return ''
  }
}

export function requestStatus(value) {
  switch(value) { 
     case 'NEW':  
        return 'คำร้องใหม่'

      case 'APPROVED':  
        return 'อนุมัติแล้ว'
     
     case 'COMPLETED':  
        return 'รับแล้ว'
     
     default: 
        return ''
  }
}

export function studentRequestStatus(value) {
  switch(value) { 
    case 'NEW':  
      return 'คำขอใหม่'

    case 'PENDING_INSTRUCTOR':  
      return 'รอความเห็นจากประธานรายวิชา/อ.ประจำวิชา'
     
    case 'PENDING_OFFICER':  
      return 'รอความเห็นจากหัวหน้าสำนักงาน'
     
    case 'PENDING_DEAN':  
      return 'รอความเห็นจากคณบดี'

    case 'COMPLETED':  
      return 'เสร็จสิ้น'
     
     default: 
        return ''
  }
}

export function formatFullDate(value) {
  if(value) { 
    const d = moment(value).locale('th')
    return `${d.format('Do MMMM')} ${(d.year() + 543)}`
    // return moment([(d.year() + 543), d.month(), d.date()]).locale('th').format('LL') 
  } 
  return 
}

export function formatShortDate(value) {
  if(value) { 
    const d = moment(value).locale('th')
    return `${d.format('Do/MM')}/${(d.year() + 543)}`
    // return moment([(d.year() + 543), d.month(), d.date()]).locale('th').format('L') 
  } 
  return 
}


// WEBPACK FOOTER //
// ./src/filters/index.js